// payrollPeriodic.js (Service File)
// DAILY / WEEKLY / BIWEEKLY / HOURLY payroll runs - pms_salary_slip_periodic.
// Monthly payroll stays in CI4; this is the new engine's API only.
import axiosInstance from "../Axios";

export const PAYROLL_STATUS = {
  DRAFT: 0,
  GENERATED: 1,
  APPROVED: 3,
  REJECTED: 4,
};

export const PAYROLL_STATUS_LABELS = {
  [PAYROLL_STATUS.DRAFT]: "Draft",
  [PAYROLL_STATUS.GENERATED]: "Generated",
  [PAYROLL_STATUS.APPROVED]: "Approved",
  [PAYROLL_STATUS.REJECTED]: "Rejected",
};

function getPayrollRuns(pageNo = 1, params) {
  const queryParams = { pageNo };
  if (params && Object.keys(params).length > 0) Object.assign(queryParams, params);
  return axiosInstance.get("/payroll/periodic", { params: queryParams });
}

function getPayrollRunDetails(id) {
  return axiosInstance.get(`/payroll/periodic/${id}`);
}

function downloadPayslip(id) {
  return axiosInstance.get(`/payroll/periodic/${id}/payslip`, { responseType: "blob" });
}

function calculatePayroll(data) {
  return axiosInstance.post("/payroll/periodic/calculate", data);
}

function generatePayroll(data) {
  return axiosInstance.post("/payroll/periodic/generate", data);
}

function generatePayrollBulk(data) {
  return axiosInstance.post("/payroll/periodic/generate-bulk", data);
}

function approvePayroll(id) {
  return axiosInstance.post(`/payroll/periodic/${id}/approve`);
}

function rejectPayroll(id) {
  return axiosInstance.post(`/payroll/periodic/${id}/reject`);
}

function holdPayroll(id, isHold, holdReason) {
  return axiosInstance.post(`/payroll/periodic/${id}/hold`, { is_hold: isHold, hold_reason: holdReason || null });
}

export {
  getPayrollRuns,
  getPayrollRunDetails,
  downloadPayslip,
  calculatePayroll,
  generatePayroll,
  generatePayrollBulk,
  approvePayroll,
  rejectPayroll,
  holdPayroll,
};
